module.exports = __webpack_public_path__ + "img/warning.cd487a3f.png";